"use strict";

require("../../style/index.less");

require("./index.less");

require("../../empty/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/select/style/index.js
// module id = 50
// module chunks = 1